import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import background_img from "../img/People_back.png";
import younggonkim from "../img/younggonkim.png";
import hyeonhoekim from "../img/hyeonhoekim.png";
import cheolkwak from "../img/cheolkwak.png";
import kujahyeon from "../img/kujahyeon.png";
import kimkwangsoo from "../img/kimkwangsoo.png";
import konghyounjoong from "../img/hyounjoongkong.png";
import yukhyeongdong from "../img/yukhyeongdong.png";
function People_item_1 (){
    return (
      <Category_wrapper>
          <Item_wrapper>
          <Span_div>
            <Content_span>
              Collaborators
            </Content_span>
            <Content_span2>
            </Content_span2>
          </Span_div>
        <Category_list_ul>
          <Category_list_li>
          <Item_img src={younggonkim}/>
          <Item_content_wrapper>
                <Item_span_title>
                Pf. Young-Gon Kim<br/> PhD 
                </Item_span_title>
                <Item_content>
                Transdisciplinary Department of Medicine & Advanced Technology 
                </Item_content>
            </Item_content_wrapper>
            </Category_list_li>
          <Category_list_li>
          <Item_img src={kimkwangsoo}/>
          <Item_content_wrapper>
                <Item_span_title>
                Pf. Kwangsoo Kim<br/> PhD 
                </Item_span_title>
                <Item_content>
                Transdisciplinary Department of Medicine & Advanced Technology 
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          <Category_list_li>
            <Item_img src={konghyounjoong}/>
            <Item_content_wrapper>
                <Item_span_title>
                Pf. Hyoun-Joong Kong<br/> PhD 
                </Item_span_title>
                <Item_content>
                Transdisciplinary Department of Medicine & Advanced Technology 
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>
        <Category_list_ul>
        <Category_list_li>
            <Item_img src={hyeonhoekim}/>
            <Item_content_wrapper>
                <Item_span_title>
                Pf. Hyeon Hoe Kim<br/> MD, PhD
                </Item_span_title>
                <Item_content>
                Department of Urology
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>

        <Category_list_li>
            <Item_img src={cheolkwak}/>
            <Item_content_wrapper>
                <Item_span_title>
                Pf. Cheol Kwak<br/> MD, PhD 
                </Item_span_title>
                <Item_content>
                Department of Urology
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          <Category_list_li>
          <Item_img src={kujahyeon}/>
          <Item_content_wrapper>
                <Item_span_title>
                Pf. Ja Hyeon Ku<br/> MD, PhD 
                </Item_span_title>
                <Item_content>
                Department of Urology
                </Item_content>
            </Item_content_wrapper>
            </Category_list_li>
          <Category_list_li>
          <Item_img src={yukhyeongdong}/>
          <Item_content_wrapper>
                <Item_span_title>
                Pf. Hyeong Dong Yuk<br/> MD, PhD 
                </Item_span_title>
                <Item_content>
                Department of Urology
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>
        </Item_wrapper>
      </Category_wrapper>
    )
  }
  const Item_wrapper = styled.div`
    width : 880px;
    margin : 70px auto;
  `
  const Item_content_wrapper = styled.div`
    padding : 5px 10px;
    text-align : left;
  `
  const Item_span_title = styled.div`
    font-weight : bold;
    font-size : 15px;
    text-align : center;
    padding : 10px 5px ;
    line-height : 25px;
    font-family: "People_name";        
  `
  const Item_content = styled.div`
    font-size : 12px;
    text-align : center;
    padding : 0 5px ;
    font-family: "People_content";        
  `
  const Item_img = styled.img`
    width : 160px;
    height :160px; 
    margin : 15px;
    border-radius : 100%;
  `
  const Category_wrapper = styled.div`
    width : 1200px;
    background : url(${background_img});
    overflow : hidden;
    margin : 0px auto;
    padding : 50px 0;
    
    `
  const Category_list_ul=styled.ul`
  font-family: "Ko";        
    display : table; 
    padding : 0 ;
    &:nth-child(2){
        margin: 10px 0 50px 100px;
    }
  `
  const Category_list_li = styled.li`
    position : relative;
    display : inline-block;
    margin-right : 20px;
    margin-bottom : 10px;
    width : 200px;
    height :320px;
    text-align : center;
    vertical-align : top;
    box-shadow: 5px 3px 5px rgba(70, 70, 70, 0.2);
    background: white;
    `
  const Content_span = styled.span`
  font-family: "Title";        

    display : block;
    font-size : 35px; 
    font-weight : bold; 
    width : 350px;
    box-sizing : border-box  ;
  `
  const Content_span2 = styled.span`
  display : inline-block;
  font-size : 20px; 
  margin: 20px 0; 
  height : 30px;
  `
  const Span_div = styled.div`
    width : 550px;
    text-align : left; 
  `
  
  export default People_item_1;